import { ref } from "vue"

export const useDragScroll = () => {
    const isDragDown = ref(false)
    const startX = ref(0)
    const scrollLeft = ref(0)

    const mouseDownAction = (e, el) => {
        isDragDown.value = true
        el.classList.add('active','grabbing')
        startX.value = e.pageX - el.offsetLeft
        scrollLeft.value = el.scrollLeft
    }

    const mouseupAction = (e, el) => {
        isDragDown.value = false
        el.classList.remove('active','grabbing')
    }

    const mousemoveAction = (e, el) => {
        if (!isDragDown.value) return
        e.preventDefault()
        const x = e.pageX - el.offsetLeft
        const walk = (x - startX.value) * 1 //scroll-fast
        el.scrollLeft = scrollLeft.value - walk
    }


    const vDragScroll = {
        mounted: (el) => {
            el.classList.add('grab')
            el.addEventListener('mousedown', ((e) => mouseDownAction(e,el)))
            el.addEventListener('mouseleave', ((e) => mouseupAction(e,el)))
            el.addEventListener('mouseup', ((e) => mouseupAction(e,el)))
            el.addEventListener('mousemove', ((e) => mousemoveAction(e,el)))
        },
        unmounted: (el) => {
            el.removeEventListener('mousedown', ((e) => mouseDownAction(e,el)))
            el.removeEventListener('mouseleave', ((e) => mouseupAction(e,el)))
            el.removeEventListener('mouseup', ((e) => mouseupAction(e,el)))
            el.removeEventListener('mousemove', ((e) => mousemoveAction(e,el)))
        }
    }

    return {
        vDragScroll
    }
}